var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatText = function SvgIconChatText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 6.25v14.096l2.67-2.24a1 1 0 0 1 .311-.178l.347-.122a1 1 0 0 1 .331-.056H20V6.25zM2.513 4.763A1.75 1.75 0 0 1 3.75 4.25h16.5A1.75 1.75 0 0 1 22 6v12a1.75 1.75 0 0 1-1.75 1.75H7.83l-.014.005-2.945 2.47-.005.005A1.75 1.75 0 0 1 2 20.895V6c0-.464.184-.91.513-1.237M8 10.125a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 3.75a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatText;